/**
 * Copyright 2025 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */

const bitRates = [
  {
    label: '5500 kbps',
    value: 'uhd'
  },
  {
    label: '3000 kbps',
    value: 'fhd'
  },
  {
    label: '1600 kbps',
    value: 'hd'
  },
  {
    label: '830 kbps',
    value: 'sd'
  },
  {
    label: '520 kbps',
    value: 'ld'
  },
  {
    label: '350 kbps',
    value: 'vld'
  },
  {
    label: '192 kbps',
    value: 'vvld'
  },
  {
    label: '80 kbps',
    value: 'uld'
  }
];

export {bitRates};